import { colors } from '../../colors';
var imageGallery = {
  primaryColor: colors.white,
  bgColor: colors.graphite,
  tileBgColor: colors.white,
  iconBgColor: colors.graphite,
  borderRadius: '20px'
};
export default imageGallery;